import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {TaxReturnsModule} from "./tax-returns/tax-returns.module";
import {TaxpayersSearchComponent} from "./taxpayers-search/taxpayers-search.component";
import {AuthGuard} from "./login/auth-guard/auth.guard";
import {ConfirmDeactivateGuard} from "./clients/client/populations/population-rules/route-guard";

const routes: Routes = [
  {
    path: "search",
    component: TaxpayersSearchComponent,
    // loadChildren: () => import("./taxpayers-search/taxpayers-search.component").then(m => m.TaxpayersSearchComponent),
    data: {
      hideSidebar: true,
    },
    canActivate: [AuthGuard],
  },
  {
    path: "",
    pathMatch: 'full',
    redirectTo: "search"
  },
  {
    path: "*",
    pathMatch: 'full',
    redirectTo: "search",
    canDeactivate: [ConfirmDeactivateGuard]
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [TaxReturnsModule, RouterModule.forRoot(routes, {})],
})
export class AppRoutingModule {
}
